import React, { useState } from "react";
import "../../assets/styles/auth/auth.css";
import Icon from "../../components/ui/icon";
import { useNavigate, useParams } from "react-router-dom";
import { useToast } from "../../context/toastContext";
import axios from "axios";
import DOMPurify from "dompurify";
import HorizontalLogo from '../../assets/logos/horizontal-logo.png';

const ResetPasswordPage = () => {
    const [isTCChecked, setisTCChecked] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [password, setPassword] = useState("");
    const [isForgetBtnD, setIsForgetBtnD] = useState(false);
    const { verificationToken } = useParams();
    const navigate = useNavigate();
    const showToast = useToast();

    const sanitizeInput = (value) => DOMPurify.sanitize(value);

    const handelLoginBtn = () => {
        if (isForgetBtnD) return;
        setIsForgetBtnD(true);

        const sanitizedPaswword = sanitizeInput(password);

        if (sanitizedPaswword.length <= 6) {
            document.getElementById("password").focus();
            navigator.vibrate([200]);
            setIsForgetBtnD(false);
            return;
        }

        if (!isTCChecked) {
            showToast({
                status: "error",
                message: "Accept Our Conditions.",
            });
            setIsForgetBtnD(false);
            return;
        }

        axios
            .post(`${window.location.origin === 'http://localhost:3000' ? 'http://localhost:5500' : window.location.origin}/api/password/reset`, {
                token: verificationToken,
                newPassword: sanitizedPaswword
            })
            .then((response) => {
                if (response.data.status) {
                    showToast({
                        status: "success",
                        message: response.data?.message || "Password Reset Successful",
                    });

                    localStorage.setItem("aToken", response.data.token);
                    if (response.data.userType === "employee" || response.data.userType === "admin") {
                        navigate("/admin");
                    } else {
                        navigate("/");
                    }
                } else {
                    showToast({
                        status: "error",
                        message: response.data?.message || "Password Reset Failed.",
                    });
                }
            })
            .catch((error) => {
                showToast({
                    status: "error",
                    message: error.response?.data?.message || "Something went wrong.",
                });
            })
            .finally(() => {
                setIsForgetBtnD(false);
            });
    };

    return (
        <div className="login__page">
            <div className="company-info">
                <img src={HorizontalLogo} alt="Company Logo" />
                <h1>Swift Digital Ads</h1>
                <p>
                    Someone who not just help you grow but also help you track your growth
                </p>
            </div>

            <div className="main-content">
                <h1>Create a new password</h1>
                <p>
                    Enter a new password below to regain access to your account securely.
                </p>

                <div className="login-form">
                    <div className="inp-box">
                        <label htmlFor="password">Password</label>
                        <div className="inp-with-btn">
                            <input
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                type={showPassword ? "text" : "password"}
                                id="password"
                                placeholder="*********"
                            />
                            <button onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <Icon name="EyeSlash" /> : <Icon name="Eye" />}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="tc-sec">
                    <div
                        onClick={() => setisTCChecked(!isTCChecked)}
                        className={`tc-box ${isTCChecked ? "checked" : ""}`}
                    >
                        <Icon name="Check" />
                    </div>
                    <p>I accept <a href="https://swiftdigitalads.com/doc/terms" target="_blank" rel="noreferrer">terms & conditions</a> and <a href="https://swiftdigitalads.com/doc/privacy" target="_blank" rel="noreferrer">privacy policy</a>.</p>
                </div>

                <button
                    className="login-btn"
                    onClick={handelLoginBtn}
                    disabled={isForgetBtnD}
                >
                    {isForgetBtnD ? (
                        <>
                            Sending... <Icon name="ArrowPath" className="icon-spin" />
                        </>
                    ) : (
                        <>
                            Reset Password <Icon name="ChevronRight" />
                        </>
                    )}
                </button>
            </div>
        </div>
    );
};

export default ResetPasswordPage;